import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
import Slider from 'react-slick';
 
import axios from 'axios';  
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {api_base_url, base_url} from '../common/Constants';

 
class SpecialOfferProducts extends React.Component{

    constructor(){
        super();

        
        this.state = {
            products : [],
            loading : 1,
            nav1:null
        }
        

    }

    componentDidMount()
    {
           const script = document.createElement("script");
                     script.src   = base_url+"assets/js/loadSlider.js";  
                     script.async = true;
                     document.body.appendChild(script);
         
                     script.onload = () => {
                     if (window.loadProductSlider && this.state.loading == 1 ) {
                      window.saleSlider();
                     this.setState({loading:0})
                     }
                     };
        
    }


    render()
    { 
        var products = JSON.parse(localStorage.getItem("products"));
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
         <div class="overflow-hidden">
            <div class="ul-container">
                <div class="ul-flash-sale">
                    <div class="ul-inner-container">
                        
                        <div class="ul-section-heading ul-flash-sale-heading">
                            <div class="left">
                                <span class="ul-section-sub-title">New Collection</span>
                                <h2 class="ul-section-title">Trending Flash Sell</h2>
                            </div>

                 

                            <Link to={base_url+"shop"} class="ul-btn">View All Collection <i class="flaticon-up-right-arrow"></i></Link>
                        </div>

                        
                        <div class="ul-flash-sale-slider swiper">
                            <div class="swiper-wrapper">
                                
                            
                           
                                    {products.map((item,key)=>( 
                                                                       
                                        <div class="swiper-slide">
                                            <div class="ul-product">
                                            
    
                                                <div class="ul-product-img">
                                                    <img src={item.image} alt={item.title} />
    
                                                    {/**** <div class="ul-product-actions">
                                                            <button><i class="flaticon-shopping-bag"></i></button>
                                                        <Link  to="#"><i class="flaticon-hide"></i></Link>
                                                        <button><i class="flaticon-heart"></i></button>
                                                    </div> **/ }
    
                                                         <span class={item.discount > 0 ? "ul-product-discount-tag" : "ul-product-discount-tag dnone"}>{item.discount}% Off</span>   
                                                </div>
    
                                                <div class="ul-product-txt">
                                                    <h4 class="ul-product-title"><Link  to={base_url+"products/"+item.slug} >{item.title}</Link></h4>
                                        
                                                </div>
    
                                                    <div class="ul-product-heading">
                                                    
                                               <span class="ul-product-price">{item.price} {item.old_price != item.price && (<label>{item.old_price}</label>  )}</span>
                                                <Link  to={base_url+"products/"+item.slug}  class={item.quantity > 0 ? " add-button" : "dnone"}>Buy Now</Link>
                                                                                         <label class={item.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                                                                        </div>
                                            </div>
                                        </div>
    
                                    ))}
                                 

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

}

export default SpecialOfferProducts;